import * as React from "react";
import { Edit, SimpleForm, AutocompleteInput, TextInput, ArrayInput, SimpleFormIterator, ReferenceArrayInput, SelectArrayInput } from 'react-admin';

export const ExternalUpdate = props => (
  <Edit title="Edit External" undoable={false} {...props}>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="label" required />
      <TextInput source="email" required />
      <ReferenceArrayInput source="rules" reference="rules">
        <SelectArrayInput optionText="title" optionValue="_id" />
      </ReferenceArrayInput>
      <AutocompleteInput source="response_type" label="Response Type" choices={[
        { id: 'API', name: 'API' },
        { id: 'EMAIL', name: 'EMAIL' },
      ]} />
      <AutocompleteInput source="request.content_type" label="Request Type" choices={[
        { id: 'JSON', name: 'JSON' },
        { id: 'FORM-DATA', name: 'FORM-DATA' },
        { id: 'SOAP', name: 'SOAP' },
      ]} />
      <TextInput source="request.url" label="Request URL" />
      <AutocompleteInput source="request.method" label="Request Method" choices={[
        { id: 'GET', name: 'GET' },
        { id: 'POST', name: 'POST' },
        { id: 'PUT', name: 'PUT' },
        { id: 'PATCH', name: 'PATCH' },
        { id: 'DELETE', name: 'DELETE' },
      ]} />
      <ArrayInput source="request.headers" label="Request Headers">
        <SimpleFormIterator>
          <TextInput source="key" label="Header name" />
          <TextInput source="value" label="Header value" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);

// "request": {
//   "url": "http://localhost:8000/api/v1/sandbox/external_data",
//   "method": "POST",
//   "headers": { }
// }
